import * as React from "react"

import { BasicTextarea, BasicTextareaProps } from "./textarea"

type Props = {
  onChange: (values: string[]) => void
  values: string[]
} & Omit<BasicTextareaProps, "defaultValue" | "onChange" | "value">

/**
 * A textarea that handles an array of string as values,
 * rendering each value on a new line
 * Purpose: let users copy/paste columns of data from a spreadsheet (E.g. phone numbers to upload)
 */
export function MultiTextarea({
  onChange,
  ref,
  values,
  ...other
}: { ref?: React.Ref<HTMLTextAreaElement> } & Props) {
  return (
    <BasicTextarea
      ref={ref}
      value={stringify(values)}
      onChange={(e) => onChange(parse(e.target.value))}
      rows={10}
      {...other}
    />
  )
}

function stringify(values: string[]) {
  return values.join("\n")
}

function parse(value: string) {
  return value ? value.split("\n") : []
}
